import React from "react";
import { ArrowDown, ArrowRight } from "lucide-react";
import { IMG, SITE } from "../lib/data";
import { AriakeMark } from "./AriakeLogo";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-[100svh] w-full overflow-hidden bg-black text-white"
      data-testid="hero-section"
    >
      <img
        src={IMG.heroBg}
        alt="Inmobiliaria House & Home — proyectos en Tumbaco"
        className="absolute inset-0 h-full w-full object-cover object-center"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/55 to-black/40" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/20 to-transparent" />

      <div className="container-hh relative z-10 pt-32 md:pt-40 pb-28 md:pb-36 min-h-[100svh] flex flex-col justify-between">
        <div>
          <div className="flex items-center gap-3 sm:gap-4 reveal">
            <span className="accent-line" style={{ background: "hsl(var(--hh-sunrise))" }} />
            <span className="overline text-white/70" style={{ fontSize: "0.62rem" }}>
              Inmobiliaria · Desde 2002
            </span>
          </div>

          <div className="mt-8 md:mt-10 max-w-3xl reveal">
            <h1
              className="font-display text-[clamp(2.4rem,9vw,7rem)] leading-[1.02] text-balance text-white"
              data-testid="hero-headline"
            >
              ¡Encuentra tu nuevo{" "}
              <span style={{ fontStyle: "italic", color: "hsl(var(--hh-sunrise))" }}>
                hogar!
              </span>
            </h1>
            <p className="mt-6 md:mt-8 max-w-xl text-white/80 text-sm md:text-lg leading-relaxed font-light">
              25 años construyendo hogares en Tumbaco. Conoce nuestros proyectos
              disponibles y descubre el lugar donde quieres despertar.
            </p>

            <div className="mt-8 md:mt-10 flex flex-wrap gap-2 sm:gap-3">
              <a href="#proyectos" className="btn-hh btn-hh-sunrise" data-testid="hero-cta-projects">
                Ver proyectos
              </a>
              <a href="#contacto" className="btn-hh btn-hh-ghost" data-testid="hero-cta-contact">
                Contáctanos
              </a>
              <a
                href={SITE.brochureUrl}
                download
                className="btn-hh btn-hh-ghost"
                data-testid="hero-cta-brochure"
              >
                Brochure Ariake
              </a>
            </div>
          </div>
        </div>

        {/* Bottom announcement strip — featured project */}
        <a
          href="#ariake"
          data-testid="hero-featured-project"
          className="reveal group mt-12 md:mt-0 flex items-center justify-between gap-4 sm:gap-6 border-t border-white/15 pt-5 sm:pt-6 hover:border-white/40 transition-colors"
        >
          <div className="flex items-center gap-3 sm:gap-4">
            <AriakeMark className="h-7 w-7 md:h-9 md:w-9 float-sun shrink-0" color="hsl(35, 58%, 60%)" />
            <div className="min-w-0">
              <div className="overline text-[hsl(var(--hh-sunrise))]" style={{ fontSize: "0.6rem" }}>
                Proyecto destacado
              </div>
              <div className="font-display text-lg sm:text-2xl md:text-3xl truncate">
                Ariake · <span className="italic text-white/70">Tu hogar, un nuevo amanecer</span>
              </div>
            </div>
          </div>
          <span className="hidden sm:inline-flex items-center gap-2 overline text-white/70 group-hover:text-white shrink-0" style={{ fontSize: "0.62rem" }}>
            Conocer <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
          </span>
          <ArrowRight size={20} className="sm:hidden text-white/70 group-hover:text-white shrink-0" />
        </a>
      </div>

      <a
        href="#nosotros"
        className="absolute bottom-3 left-1/2 -translate-x-1/2 z-10 text-white/40 hover:text-white transition-colors"
        data-testid="hero-scroll-cue"
        aria-label="Bajar"
      >
        <ArrowDown size={16} className="animate-bounce" />
      </a>
    </section>
  );
}
